import { CategoryModel } from './CategoryModel';

export class CategoryFormModel {
    static normalizeBeforeSubmit(cat: CategoryFormModel): CategoryFormModel {
        cat.parent = undefined
        return cat
    }

    id?: string|number = undefined;
    idParent?: string|number|null = undefined;
    idSource?: string = "";
    name: string = "";
    title: string = "";
    description: string = "";
    keywords: string = "";
    parent?: CategoryModel|null = new CategoryModel();
    isActive: boolean = true
    allowExport: boolean = true

    constructor(c?: Partial<CategoryModel>) {
        this.id = c?.id
        this.idParent = c?.idParent || undefined
        this.idSource = c?.idSource || undefined
        this.name = c?.name || ""
        this.title = c?.title || ""
        this.description = c?.description || ""
        this.keywords = c?.keywords || ""
        this.parent = new CategoryModel(c?.parent) || undefined
        this.isActive = c?.isActive ?? true
        this.allowExport = c?.allowExport ?? true
    }

    isValid():boolean {
        return !!this.name
    }

    hasId():boolean {
        return !!this.id
    }

    hasIdSource():boolean {
        return !!this.idSource
    }

    hasParent():boolean {
        return !!this.idParent
    }

    removeParent():void {
        this.parent = null
        this.idParent = null
    }
}
